import { render } from "./IconAlignTextRight.vue?vue&type=template&id=49043380"
import script from "./IconAlignTextRight.vue?vue&type=script&lang=js"
export * from "./IconAlignTextRight.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__